export default "__VITE_ASSET__DUyd5ato__"